import URI from 'urijs'
import { pluralize } from '@polleverywhere/core/lib/util'

export default (model) => {
  if (!model.has('type')) {
    return false
  }

  if (!model.has('permalink') && !model.has('permalink')) {
    return false
  }

  return URI(pluralize(2, model.get('type')))
    .segment(model.get('presenter_key') || model.get('permalink'))
    .toString()
}
